// extracted by mini-css-extract-plugin
module.exports = {"container":"slippageLost_container__bUebT","warn":"slippageLost_warn__02Zgr"};